module.exports = __webpack_public_path__ + "static/media/RestAPI.a0c6eccd.png";